import { Component1Icon } from "@radix-ui/react-icons";
import {
  ExploreGroupByColumnType,
  exploreColumnTypeToLabel,
  exploreGroupByColumnTypeToLabel,
} from "@/v2/entities/explore/columns/ExploreColum.model";
import { ExploreColumnType } from "@/v2/entities/explore/columns/ExploreColum.model";
import {
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { ScrollArea } from "@/components/ui/scroll-area";
import Select from "@/components/shared/select";
import { HamburgerMenuIcon } from "@radix-ui/react-icons";
import { Hamburger, Menu } from "lucide-react";

interface GroupingSectionProps {
  groupByLabel: string;
  currentGroupBy?: ExploreGroupByColumnType;
  availableOptions: ExploreGroupByColumnType[];
  onGroupByChange: (groupBy: ExploreGroupByColumnType | "none") => void;
}

export function GroupingSection({
  groupByLabel,
  currentGroupBy,
  availableOptions,
  onGroupByChange,
}: GroupingSectionProps) {
  const allGroupByOptions = [
    { label: "No grouping", value: "none" },
    ...availableOptions.map((option) => ({
      label: exploreGroupByColumnTypeToLabel[option].plural,
      value: option,
    })),
  ];

  return (
    <div className="flex items-center gap-1 w-full">
      <div className="flex items-center w-[125px] flex-shrink-0 gap-1">
        <Menu className="text-gray-500 size-4" />
        <label className="text-sm text-gray-500">Grouping</label>
      </div>

      <div className="flex-1 min-w-0">
        <Select
          size="medium"
          classes={{
            root: "w-full",
            value: "truncate",
          }}
          options={allGroupByOptions}
          placeholder="Select Group By"
          value={currentGroupBy}
          onChange={(value) =>
            onGroupByChange(value as ExploreGroupByColumnType)
          }
        />
      </div>
    </div>
  );
}
